// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"7c01ce60","967":"6b3975f1"}[chunkId] + ".chunk.js";
};